export default "__VITE_ASSET__FDA0EuF0__"